import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

const PermissionCheck = ({ children, permissionsList }) => {
    const permissions = useSelector(state => state.user.permissions);

    if (!permissions) {
        return null;
    }

    const checkPermissions = () => permissionsList?.some(per => permissions[per]);

    return !permissionsList || checkPermissions() ? <>{children}</> : null;
};

PermissionCheck.propTypes = {
    children: PropTypes.object,
    permissionsList: PropTypes.array,
};

export default PermissionCheck;
